// extracted by mini-css-extract-plugin
export default {"main":"palavra_main__Fai4y","text":"palavra_text__Xh5r9","button":"palavra_button__Ip35y","header":"palavra_header__PpzyE"};